// @ts-ignore
export const VERSION: string = __VERSION__;
